import React from 'react'
import styles from '../../styles'
import { makeStyles } from 'tss-react/mui'
import { CircularProgress } from '@mui/material'

const useStyles = makeStyles()((theme) => ({
	...styles(theme),
	circularProgressStyle: {
		width: '100%',
		height: '100%',
		marginBottom: 20,

		'& div': {
			width: '100px !important',
			height: '100px !important'
		}
	}
}))

interface AcceptingProps {
	size?: number | string
}

const Loader: React.FC<AcceptingProps> = (
	{
		size
	}
) => {
	const { classes, cx } = useStyles()

	const circularProgressClass = cx(
		classes.circularProgressStyle,
		classes.flex,
		classes.alignCenter,
		classes.flexCenter
	)

	return (
		<div className={cx({ [circularProgressClass]: !size })}>
			<CircularProgress size={size} />
		</div>
	)
}

export default Loader